module.exports = __webpack_public_path__ + "static/media/XXVh.231c011b.png";